/**
 * @generated SignedSource<<eb13867cda974a0b1aaf580b5940ca2e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_viewResult$data = {
  readonly viewConfigSettings?: {
    readonly hideDone: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "topBar_issueNavigator_viewResult";
};
export type topBar_issueNavigator_viewResult$key = {
  readonly " $data"?: topBar_issueNavigator_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SaveResetViewSettingsButton"
        }
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewConfigSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hideDone"
            }
          ]
        }
      ],
      "type": "JiraIssueSearchView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "d83330d88df899c90e21726ae7ed79c8";

export default node;
